import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { ImageCroppedEvent, ImageTransform, base64ToFile } from 'ngx-image-cropper';

@Component({
  selector: 'app-image-cropper',
  templateUrl: './image-cropper.component.html',
  styleUrls: ['./image-cropper.component.scss']
})
export class ImageCropperComponent {
  imageChangedEvent: any = '';
  @Output() croppedImage = new EventEmitter<Blob>();
  imgRotation = 0;
  scale = 1;
  imgTransform: ImageTransform = {scale: 1, flipH: false, flipV: false};
  noimage = true;

  constructor() { }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }
  imageCropped(event: ImageCroppedEvent) {
    const file = base64ToFile(event.base64);
    this.croppedImage.emit(file);
  }
  imageLoaded() {
    this.noimage = false;
  }
  cropperReady() {
  }
  loadImageFailed() {
  }

  public imageTransform(transformType) {
    if (transformType === 'rotate') {
        this.imgRotation = this.imgRotation + 1;
    }
    if (transformType === 'plus') {
        this.scale += .1;
        this.imgTransform = {
            ...this.imgTransform,
            scale: this.scale
        };
    }
    if (transformType === 'minus') {
        this.scale -= .1;
        this.imgTransform = {
            ...this.imgTransform,
            scale: this.scale
        };
    }
    if (transformType === 'flipH') {
        this.imgTransform = {
            ...this.imgTransform,
            flipH: !this.imgTransform.flipH
        };
    }
    if (transformType === 'flipV') {
        this.imgTransform = {
            ...this.imgTransform,
            flipV: !this.imgTransform.flipV
        };
    }
  }

}
